import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/components/ui";
import Seo from "@/components/Seo";
import { ImmersiveShell } from "@/components/immersive/ImmersiveShell";
import { Reveal } from "@/components/immersive/Reveal";
import Breadcrumbs from "@/components/immersive/Breadcrumbs";
import { CtaCluster } from "@/components/immersive/MarketingBits";
import { FAQS } from "@/lib/content";

export default function Faqs() {
  const ld = {
    "@context": "https://schema.org", "@type": "FAQPage",
    "mainEntity": FAQS.map((f) => ({ "@type": "Question", "name": f.q, "acceptedAnswer": { "@type": "Answer", "text": f.a } })),
  };
  return (
    <ImmersiveShell>
      <Seo title="FAQs About Home Care Services" path="/faqs"
        description="Frequently asked questions about home care services, senior care matching, and caregiver matching with HomecareMatches."
        keywords="home care services faq, senior care matching, caregiver matching, in-home care" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }} />
      <section className="imm-mkt-hero imm-wrap" data-testid="faqs-page">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "FAQs" }]} />
        <Reveal className="imm-eyebrow" delay={80}>Good to know</Reveal>
        <Reveal as="h1" delay={180}>Frequently Asked Questions About Home Care Services</Reveal>
      </section>

      <section className="imm-wrap" data-testid="faqs-list" style={{ paddingBottom: "6vh" }}>
        {FAQS.map((f, i) => (
          <Reveal key={i} delay={i * 55}><div className="imm-feature" data-testid={`faq-${i}`}><span className="fnum"><Icon name="help-circle" size={20} /></span><div><h2 className="imm-svc-h2">{f.q}</h2><p>{f.a}</p></div></div></Reveal>
        ))}
        <Reveal delay={120}><p style={{ marginTop: 20 }}><Link className="imm-inline-link" to="/how-it-works">See how our matching process works <Icon name="arrow-right" size={15} /></Link></p></Reveal>
      </section>

      <section className="imm-wrap" data-testid="faqs-cta" style={{ paddingBottom: "8vh" }}>
        <Reveal as="h2" className="imm-svc-h2">Still have questions?</Reveal>
        <Reveal delay={80}><div style={{ marginTop: 18 }}><CtaCluster /></div></Reveal>
      </section>
    </ImmersiveShell>
  );
}
